import { useCreateFieldGetter, useFieldBorder } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for Open Conversations card customisation
 * Returns open conversation card configuration and styling
 * Fields: textColor, subTextColor, backgroundColor
 */
export const useOpenCardCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CONVERSATIONS_PAGE,
    sectionKey: PUI.CONVERSATIONS_SECTION_KEYS.OPEN_CARD,
    blockKey: PUI.CONVERSATIONS_BLOCK_KEYS.BODY_SECTION,
  });

  const labelColor = getField(PUI.COMMON_FIELD_KEYS.LABEL_COLOR);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const subTextColor = getField(PUI.COMMON_FIELD_KEYS.SUB_TEXT_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const { borderColor } = useFieldBorder();

  return {
    isVisible,
    labelColor,
    textColor,
    subTextColor,
    backgroundColor,
    borderColor,
  };
};

/**
 * Composable for Closed or Resolved Conversations card customisation
 * Returns closed/resolved conversation card configuration and styling
 * Fields: textColor, subTextColor, backgroundColor, resolvedColor, closedColor
 */
export const useClosedOrResolvedCardCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CONVERSATIONS_PAGE,
    sectionKey: PUI.CONVERSATIONS_SECTION_KEYS.RESOLVED_OR_CLOSED_CARD,
    blockKey: PUI.CONVERSATIONS_BLOCK_KEYS.BODY_SECTION,
  });

  const labelColor = getField(PUI.COMMON_FIELD_KEYS.LABEL_COLOR);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const subTextColor = getField(PUI.COMMON_FIELD_KEYS.SUB_TEXT_COLOR);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const backgroundColorTagResolved = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR_TAG_RESOLVED);
  const backgroundColorTagClosed = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR_TAG_CLOSED);
  const textColorTagResolved = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR_TAG_RESOLVED);
  const textColorTagClosed = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR_TAG_CLOSED);
  const { borderColor } = useFieldBorder();

  return {
    isVisible,
    labelColor,
    textColor,
    subTextColor,
    backgroundColor,
    backgroundColorTagResolved,
    backgroundColorTagClosed,
    textColorTagResolved,
    textColorTagClosed,
    borderColor,
  };
};
